export default __webpack_public_path__ + "static/media/oummi.2aeb6705.png";